import React from "react";
import PropTypes from "prop-types";
import { Translate } from "react-localize-redux";
import Dropdown from "../../../../../shared/Input/Dropdown";
import NumberInput from "../../../../../shared/Input/NumberInput";
import Fa from "../../../../../tools/Icons/Fa";
import { resolveItemName } from "../../../../../../utils/utils";

class LockConfigurationModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const {configuration, units, path, onModify} = this.props;

		return (
			<section>
				<div className={`grid-table grid-icon-auto-1fr`}>
					<span><Fa icon={"project-diagram"} /></span>
					<label><Translate id={"feedbackChannel"} /></label>
					<NumberInput
						defaultValue={configuration.feedbackChannel || ''}
						path={`${path}.feedbackChannel`}
						onModify={onModify}
					/>

					<span><Fa icon={"microchip"} /></span>
					<label><Translate id={"communicationUnit"} /></label>
					<Dropdown
						defaultValue={configuration.communicationUnit}
						options={units.content}
						onLabel={item => resolveItemName(item)}
						onValue={item => item && ({id: item.id, name: item.name}) || null}
						path={`${path}.communicationUnit`}
						onModify={onModify}
						canInvalidate={true}
					/>
				</div>
			</section>
		)
	}
}

LockConfigurationModal.propTypes = {
	configuration: PropTypes.object.isRequired,
	units: PropTypes.object.isRequired,
	path: PropTypes.string.isRequired,

	onModify: PropTypes.func.isRequired,
};

LockConfigurationModal.stateTypes = {};

export default LockConfigurationModal;
